<template>
  <div class="online-content">
    <div class="online-studyEvaluate online-subject">
      <!-- 
        图片选择题（有图/无图）:11
        文字选择题（有图/无图）:12
        排序题（文字排序）:13
        排序题（图片排序）:14
        排序题（句子排序）:21
        填空题 (文上空下)（有图/无图）:15
        填空题(字母/单词填充)（有图/无图）:16
        连连看（图连字/图连图/字连字）:17
        判断对错选择题（有图/无图）:18
        图片点击题（可多选）:19
        拖拽题（带图/无图）:20
        阅读题 （综合题型）:22
      -->
      <!-- 图片选择 题目 -->
      <PictureSelection
        @iptChange="iptChange"
        :anwsersAll="anwsersList[question.currentId]"
        v-if="currentQuestion.category_id==11"
        :currentQuestionList="currentQuestionList"
        :currentId="question.currentId"
      ></PictureSelection>
      <!-- 文字选择 题目 -->
      <wordSelection
        @wordChange="wordChange"
        :anwsersAll="anwsersList[question.currentId]"
        v-if="currentQuestion.category_id==12"
        :currentQuestionList="currentQuestionList"
      ></wordSelection>
      <!-- 填空题 -->
      <FillBlank
        :anwsersAll="anwsersList[question.currentId]"
        @fillText="fillText"
        @fillMilte="fillMilte"
        v-if="currentQuestion.category_id==15 || currentQuestion.category_id==16"
        :currentQuestionList="currentQuestionList"
      ></FillBlank>
      <!-- 判断题 -->
      <Judge
        @judgeChange="judgeChange"
        :anwsersAll="anwsersList[question.currentId]"
        v-if="currentQuestion.category_id==18"
        :currentQuestionList="currentQuestionList"
      ></Judge>
      <!-- 图片点击 题目 -->
      <ImgClick
        @imgClickChange="imgClickChange"
        v-if="currentQuestion.category_id==19"
        :currentQuestionList="currentQuestionList"
        :anwsersAll="anwsersList[question.currentId]"
      ></ImgClick>
      <!-- 排序题 -->
      <Sort
        @dragImgClickChange="dragImgClickChange"
        @dragWordClickChange="dragWordClickChange"
        @dragTextClickChange="dragTextClickChange"
        @dragImgEndClickChange="dragImgEndClickChange"
        @dragTextEndClickChange="dragTextEndClickChange"
        v-if="currentQuestion.category_id==13 || currentQuestion.category_id==14 || currentQuestion.category_id==21"
        :currentQuestionList="currentQuestionList"
        :anwsersAll="anwsersList[question.currentId]"
        :anwsersListAll="anwsersList"
        :currentId="question.currentId"
      ></Sort>
      <!-- 拖拽题 -->
      <DragType
        @dragClickChange="dragClickChange"
        v-if="currentQuestion.category_id==20"
        :currentQuestionList="currentQuestionList"
        :anwsersAll="anwsersList[question.currentId]"
        :anwsersListAll="anwsersList"
        :currentId="question.currentId"
      ></DragType>
      <!-- 连线题 -->
      <Connection
        v-if="currentQuestion.category_id==17"
        :currentQuestionList="currentQuestionList"
        :anwsersAll="anwsersList[question.currentId]"
        :anwsersListAll="anwsersList"
        :currentId="question.currentId"
      ></Connection>
      <!-- 阅读题 -->
      <!-- {{readListContentAll}} -->
      <Read
        v-if="currentQuestion.category_id==22"
        :currentQuestionList="currentQuestionList"
        :anwsersAll="anwsersList[question.currentId]"
        :anwsersListAll="anwsersList"
        :currentId="question.currentId"
        :readListContent="readListContent"
      ></Read>
      <div class="subject-change">
        <!-- {{question.currentId}}==={{question.length}} -->
        <!-- <span class="prev btn cursor" :class="question.currentId==0?'':'cur'" @click="prevQuetion">{{$t('Evaluation.prev')}}</span> -->
        <span
          class="next btn cur cursor"
          v-html="question.currentId>=question.length-1 ? $t('Evaluation.complete'):$t('Evaluation.next')"
          @click="nextQuetion"
        ></span>
        <!-- <span
          v-if="question.currentId>=question.length-1"
          class="next btn cur"
          @click="completeSubmit"
        >交卷</span>
        <span v-else class="next btn cur" @click="nextQuetion">下一题</span>-->
        <!-- <span class="next btn">下一题</span> -->
      </div>
    </div>

    <!-- 退出作答题目 弹窗 -->
    <popTips
      :dialogVisable="closeItem"
      :popTipsCont="popTips_close"
      @handConfirm="handConfirmEquit"
      @handCancel="handCancelEquit"
      @handleCloseTip="handleCloseTipEquit"
    ></popTips>
    <!-- 超时 弹窗 -->
    <popTips
      :dialogVisable="timeOutItem"
      :popTipsCont="popTips_timeOut"
      @handConfirm="handConfirm"
      @handCancel="timeOutItem=false"
      @handleCloseTip="handleCloseTip"
    ></popTips>
    <message :message="message" :showTip="showTip" @hideTip="hideTip" />
  </div>
</template>

<script>
import message from "@/components/Common/message";
import evaluationStore from "@/views/StudyCenter/Evaluation/Evaluation";
import PictureSelection from "@/components/TestQuestion/PictureSelection";
import wordSelection from "@/components/TestQuestion/wordSelection";
import FillBlank from "@/components/TestQuestion/FillBlank";
import Judge from "@/components/TestQuestion/Judge";
import ImgClick from "@/components/TestQuestion/ImgClick";
import Sort from "@/components/TestQuestion/Sort";
import DragType from "@/components/TestQuestion/DragType";
import Connection from "@/components/TestQuestion/Connection";
import Read from "@/components/TestQuestion/Read";
import popTips from "@/components/popTips";
export default {
  name: "subject",
  components: {
    message,
    PictureSelection, //图片选择题
    wordSelection, //文字选选择题目
    FillBlank, //填空题
    Judge, //判断题
    ImgClick, //图片 点击题
    Sort, //排序题
    DragType, //拖拽题
    Connection, //连线题
    Read, //阅读题
    popTips
  },
  data() {
    return {
      message: "",
      showTip: false,
      studentInfo: {
        token: "",
        member_id: "",
        student_id: "", //学生ID
        examine_branch: "", //检测编号
        examine_name: "", //检测名称
        textbook_id: "", //教材id
        textbook_cnname: "", //教材名称
        classcode_branch: "", //班别编号
        examAgain: 0, //是否是再考一次
        myIsErroy: 0 //是否是错题提交 - 还是正常题目提交
      },
      question: {
        currentId: 0, //当前第几题
        length: "" //题目长度
      },
      questionsIdList: [],
      closeItem: false, //删除孩子
      // 删除孩子 - 提示弹窗
      popTips_close: {
        // btn_text1: "确定删除",
        // btn_text2: "我在想想",
        title: this.$t('Common.tips'),
        context: this.$t('Common.invalid'),
        btns: [
          {
            text: this.$t('Common.quit'),
            event: "handConfirm"
          },
          {
            text: this.$t('Common.think'),
            event: "handCancel"
          }
        ]
      },
      timeOutItem: false, //超时弹窗
      // 超时弹窗 - 提示弹窗
      popTips_timeOut: {
        title:  this.$t('Common.tips'),
        context:  this.$t('Common.timeOut'),
        btns: [
          {
            text: this.$t('Common.confirm'),
            event: "handConfirm"
          }
        ]
      },
      allQuestionList: [],
      currentQuestion: {}, //当前题型 - 信息
      currentQuestionList: {}, //当前题目信息 - 传递到子组件
      anwsersList: [], //当前题目答案
      submitArr: [], //当前题目答案 - 替代
      allTime: "", //后台给的总时间
      timer_cout: "", //定时器
      remainTime: "", //考试剩余时间
      isClickNext: true, //是否可以点击下一题
      readQuestionIds: [], //阅读题 - 包含的题目数量
      readListContentAll: {
        //
      },
      readListContent: [],
      isClickPrev: true //点击下一步
    };
  },
  mounted() {
    if (window.history && window.history.pushState) {
      // 向历史记录中插入了当前页
      history.pushState(null, null, document.URL);
      window.addEventListener("popstate", this.goBack, false);
    }
    // window.addEventListener("beforeunload", e => this.beforeunloadFn(e));
  },
  updated() {},
  created() {
    this.studentInfo.token = this.$store.state.token;
    this.studentInfo.member_id = this.$store.state.member_id;
    this.studentInfo.student_id = this.$store.state.currentChild.student_id;
    this.studentInfo.examine_name = unescape(this.$route.query.examine_name);
    this.studentInfo.examine_branch = this.$route.query.examine_branch; //检测编号

    this.studentInfo.classcode_branch = this.$route.query.classcode_branch; //班别编号
    this.studentInfo.examAgain = this.$route.query.examAgain
      ? this.$route.query.examAgain
      : 0;
    this.studentInfo.myIsErroy = this.$route.query.myIsErroy
      ? this.$route.query.myIsErroy
      : 0;

    //------存储头部信息 开始------
    this.$Tool.setStorage("InfoNameQuestion", this.studentInfo.examine_name);
    this.$store.dispatch("setInfoNameQuestion", this.studentInfo.examine_name);

    //------存储头部信息 结束------
    //是否是再考考一次
    console.log(this.studentInfo.examAgain, "是否是再考考一次");
    console.log(this.$route.query.myIsErroy, "我是什么题型的提交");
    if (this.studentInfo.examAgain == 0) {
      console.log("我不是重新老师");
      this.getSubjects();
    } else if (this.studentInfo.examAgain == 1) {
      console.log("错题再练");
      this.againTest();
    }

    console.log(this.question.currentId, "当前题目");
    
  },
  watch: {},
  computed: {},
  methods: {
    hideTip() {
      this.showTip = false;
    },
    //图片选择 题
    iptChange(v1, v2) {
      console.log(v1, v2);
      console.log(this.anwsersList);
    },
    //图片选择题 多选
    imgClickChange(v1, v2) {
      console.log(v1, v2);
      console.log("图片点击");
      console.log(this.anwsersList);
    },
    //文字选择 - 单选
    wordChange(v1, v2) {
      console.log("文字选择");
      console.log(v1, v2);
      console.log(this.anwsersList);
    },
    //判断题
    judgeChange(v1, v2) {
      console.log(v1, v2);
      console.log("判断题");
      console.log(this.anwsersList);
    },
    // 填空题 (文上空下)
    fillText(v1) {
      console.log(v1);
      console.log("填空题 (文上空下) ");
      console.log(this.anwsersList);
    },
    //填空题(字母/单词填充)
    fillMilte(v1) {
      console.log(v1);
      console.log("填空题 (文上空下) ");
      console.log(this.anwsersList);
    },
    //拖拽题
    dragClickChange(v1) {
      console.log(v1);
      console.log("拖拽题");
      console.log(this.anwsersList);
    },
    //排序题 - 图片排序 上面结束
    dragImgClickChange() {
      console.log(this.anwsersList);
      console.log("排序题 - 图片排序 上面结束");
    },
    //排序题 - 图片排序 下面结束
    dragImgEndClickChange() {
      console.log(this.anwsersList);
      console.log("排序题 - 图片排序 下面结束");
    },
    //排序题 - 句子排序
    dragWordClickChange() {
      console.log(this.anwsersList);
      console.log("句子排序");
    },
    //排序题 - 文字排序 -结束 上面
    dragTextClickChange() {
      console.log(this.anwsersList);
      console.log("排序题 - 文字排序 -结束 上面");
    },
    //排序题 - 文字排序 -结束 下面
    dragTextEndClickChange() {
      console.log(this.anwsersList);
      console.log("排序题 - 文字排序 -结束 下面");
    },
    //刷新页面
    // beforeunloadFn(e) {
    //   console.log("刷新页面");
    //   this.closeItem = true;
    // },
    //上一题
    prevQuetion() {
      this.question.currentId--;
      this.isClickPrev = false;
      if (this.question.currentId < 0) {
        this.question.currentId = 0;
        //------存储头部信息 开始------
        let idIndex = this.question.currentId;
        this.$Tool.setStorage("InfocurrentQuestion", idIndex + 1);
        this.$store.dispatch("setInfocurrentQuestion", idIndex + 1);
        //------存储头部信息 结束------
      } else {
        let index = this.question.currentId;
        this.currentQuestion = this.allQuestionList[index];
        //------存储头部信息 开始------
        let idIndex = this.question.currentId;
        this.$Tool.setStorage("InfocurrentQuestion", idIndex + 1);
        this.$store.dispatch("setInfocurrentQuestion", idIndex + 1);
        //------存储头部信息 结束------
        let currentId = this.currentQuestion.question_id;
        this.getQuestion(currentId);
        // this.getSubjects();
        console.log(this.anwsersList, "返回上一题时候此时的答案结构");
      }
    },
    //下一题
    nextQuetion() {
      this.isClickPrev = true;
      if (this.question.currentId >= this.question.length) {
        this.question.currentId = this.question.length - 1;
        //------存储头部信息 开始------
        let idIndex = this.question.currentId;
        this.$Tool.setStorage("InfocurrentQuestion", idIndex + 1);
        this.$store.dispatch("setInfocurrentQuestion", idIndex + 1);
        //------存储头部信息 结束------
      } else {
        let index = this.question.currentId;
        let type = this.allQuestionList[index].category_id; //当前题目的类型
        //如果当前题目的答案为空 不能进入下一题
        if (
          type == 13 ||
          type == 14 ||
          type == 21 ||
          type == 19 ||
          type == 16
        ) {
          if (this.anwsersList[index].answers.length > 0) {
            this.showTip = false;
            this.question.currentId++;
            let indexInner = this.question.currentId;

            //------存储头部信息 开始------
            let idIndex = this.question.currentId;
            this.$Tool.setStorage("InfocurrentQuestion", idIndex + 1);
            this.$store.dispatch("setInfocurrentQuestion", idIndex + 1);
            //------ 存储头部信息 结束------

            if (this.question.currentId >= this.question.length) {
              this.currentQuestion.category_id = "";
              this.completeSubmit();
            } else {
              this.currentQuestion = this.allQuestionList[indexInner];
              let currentId = this.currentQuestion.question_id;
              this.getQuestion(currentId);
            }
          } else {
            this.message = this.$t('Common.PleaseAnswer');
            this.showTip = true;
          }
        } else if (type == 22) {
          console.log(this.anwsersList[index].answers, "阅读题答案");
          let isNoValue = 0;
          this.anwsersList[index].answers.forEach(function(item) {
            if (item.answers == "") {
              isNoValue++;
            }
          });
          if (isNoValue > 0) {
            this.message = this.$t('Common.PleaseAnswer');
            this.showTip = true;
          } else {
            this.showTip = false;
            this.question.currentId++;
            let indexInner = this.question.currentId;

            //------存储头部信息 开始------
            let idIndex = this.question.currentId;
            this.$Tool.setStorage("InfocurrentQuestion", idIndex + 1);
            this.$store.dispatch("setInfocurrentQuestion", idIndex + 1);
            //------ 存储头部信息 结束------

            if (this.question.currentId >= this.question.length) {
              this.currentQuestion.category_id = "";
              this.completeSubmit();
            } else {
              this.currentQuestion = this.allQuestionList[indexInner];
              let currentId = this.currentQuestion.question_id;
              this.getQuestion(currentId);
            }
          }
        } else if (type == 17) {
          console.log(this.anwsersList[index])
          if (this.anwsersList[index].pointsArr.length == this.anwsersList[index].topList.length) {
            this.anwsersList[index].pointsArr.forEach(e => {
              this.anwsersList[index].answers[
                e.startIndex
              ][0] = this.anwsersList[index].topList[
                e.startIndex
              ].answers_optionname;
              this.anwsersList[index].answers[
                e.startIndex
              ][1] = this.anwsersList[index].bottomList[
                e.endIndex
              ].answers_optionname;
            });
            this.showTip = false;
              this.question.currentId++;
              let indexInner = this.question.currentId;

              //------存储头部信息 开始------
              let idIndex = this.question.currentId;
              this.$Tool.setStorage("InfocurrentQuestion", idIndex + 1);
              this.$store.dispatch("setInfocurrentQuestion", idIndex + 1);
              //------ 存储头部信息 结束------

              if (this.question.currentId >= this.question.length) {
                this.currentQuestion.category_id = "";
                this.completeSubmit();
              } else {
                this.currentQuestion = this.allQuestionList[indexInner];
                let currentId = this.currentQuestion.question_id;
                this.getQuestion(currentId);
              }
            console.log(this.anwsersList[index].answers);
          } else {
            this.message = this.$t('Common.PleaseAnswer');
            this.showTip = true;
          }

          // let linkFlag = 0;
          // if (this.anwsersList[index].answers.length > 0) {
          //   this.anwsersList[index].answers.forEach(function(item) {
          //     console.log(item);
          //     console.log(item[0], item[1]);
          //     if (item[0] == -1 || item[1] == -1) {
          //       linkFlag++;
          //     }
          //   });
          //   console.log(linkFlag);
          //   if (linkFlag > 0) {
          //     this.message = this.$t('Common.PleaseAnswer');
          //     this.showTip = true;
          //   } else {
          //     this.showTip = false;
          //     this.question.currentId++;
          //     let indexInner = this.question.currentId;

          //     //------存储头部信息 开始------
          //     let idIndex = this.question.currentId;
          //     this.$Tool.setStorage("InfocurrentQuestion", idIndex + 1);
          //     this.$store.dispatch("setInfocurrentQuestion", idIndex + 1);
          //     //------ 存储头部信息 结束------

          //     if (this.question.currentId >= this.question.length) {
          //       this.currentQuestion.category_id = "";
          //       this.completeSubmit();
          //     } else {
          //       this.currentQuestion = this.allQuestionList[indexInner];
          //       let currentId = this.currentQuestion.question_id;
          //       this.getQuestion(currentId);
          //     }
          //   }
          // } else {
          //   this.message = this.$t('Common.PleaseAnswer');
          //   this.showTip = true;
          // }
        } else {
          console.log("可我走了这里");
          if (this.anwsersList[index].answers != "") {
            this.showTip = false;
            this.question.currentId++;
            let indexInner = this.question.currentId;

            //------存储头部信息 开始------
            let idIndex = this.question.currentId;
            this.$Tool.setStorage("InfocurrentQuestion", idIndex + 1);
            this.$store.dispatch("setInfocurrentQuestion", idIndex + 1);
            //------存储头部信息 结束------

            if (this.question.currentId >= this.question.length) {
              this.currentQuestion.category_id = "";
              this.completeSubmit();
            } else {
              this.currentQuestion = this.allQuestionList[indexInner];
              let currentId = this.currentQuestion.question_id;
              this.getQuestion(currentId);
            }
          } else {
            this.message = this.$t('Common.PleaseAnswer');
            this.showTip = true;
          }
        }
      }
    },
    //获取 测评 题目
    getSubjects() {
      this.$store.dispatch("setLoadingStatus", true);
      evaluationStore
        .getSubjects({
          token: this.studentInfo.token, //登陆获取token
          member_id: this.studentInfo.member_id, //登陆获取的会员表
          student_id: this.studentInfo.student_id,
          examine_branch: this.studentInfo.examine_branch, //检测编号
          is_analysis: "" //	是否需要题目分析 1-需要 不传为不需要
        })
        .then(res => {
          if (res.data.error == 0) {
            let list = res.data.result.list;
            this.allQuestionList = list;
            this.question.length = list.length;

            this.currentQuestion = list[0];
            let arr = [];
            let _this = this;

            this.allTime = res.data.result.test_time * 60; //秒;
            this.$Tool.setStorage("allTime", this.allTime);
            if (this.$Tool.getStorage("remainTime")) {
              console.log("考试时间");
              
              if(this.$Tool.getStorage("remainTime")==0){
                this.$store.dispatch("setRemainTime", this.allTime);
              }else{
                this.remainTime = this.$Tool.getStorage("remainTime");
                this.$store.dispatch("setRemainTime", this.remainTime);
              }
            } else {
              console.log("刚开始考试时间等于 后台给的总时间");
              //刚开始考试时间等于 后台给的总时间
              this.remainTime = this.allTime;
              this.$Tool.setStorage("remainTime", this.remainTime); //考试时间
              this.$store.dispatch("setRemainTime", this.remainTime);
            }
            this.countTime();

            //------存储头部信息 开始------
            let idIndex = this.question.currentId;
            this.$Tool.setStorage("InfocurrentQuestion", idIndex + 1);
            this.$store.dispatch("setInfocurrentQuestion", idIndex + 1);
            this.$Tool.setStorage("InfoAllQuestion", this.question.length);
            this.$store.dispatch("setInfoAllQuestion", this.question.length);
            //------存储头部信息 结束------
            let currentId = this.currentQuestion.question_id;
            this.getQuestion(currentId); //获取题目详情
          }
          this.$store.dispatch("setLoadingStatus", false);
        });
    },
    //再考一次 - 错题
    againTest() {
      if (this.$Tool.getStorage("getCodeInfo")) {
        console.log(this.$Tool.getStorage("getCodeInfo").wrong_ids);
        console.log(this.$Tool.getStorage("getCodeInfo").wrong_idArray);
        let list = this.$Tool.getStorage("getCodeInfo").wrong_idArray;
        this.allQuestionList = list;
        this.question.length = list.length;

        this.currentQuestion = list[0];
        let arr = [];
        let _this = this;
        console.log(this.anwsersList);

        this.allTime = this.$Tool.getStorage("allTime"); //秒;
        console.log(this.allTime);
        if (this.$Tool.getStorage("remainTime")) {
          this.remainTime = this.allTime;
          this.$Tool.setStorage("remainTime", this.remainTime); //考试时间
          this.$store.dispatch("setRemainTime", this.remainTime);
        } else {
          console.log("刚开始考试时间等于 后台给的总时间");
        }
        this.countTime();

        //------存储头部信息 开始------
        let idIndex = this.question.currentId;
        this.$Tool.setStorage("InfocurrentQuestion", idIndex + 1);
        this.$store.dispatch("setInfocurrentQuestion", idIndex + 1);
        this.$Tool.setStorage("InfoAllQuestion", this.question.length);
        this.$store.dispatch("setInfoAllQuestion", this.question.length);
        //------存储头部信息 结束------
        let currentId = this.currentQuestion.question_id;
        this.getQuestion(currentId); //获取题目详情
      }
    },
    // 考试时间倒计时(精确到秒)
    countTime() {
      //时间差
      this.timer_cout = setInterval(() => {
        if (this.remainTime > 0) {
          --this.remainTime;
        } else {
          clearInterval(this.timer_cout);
          this.remainTime = 0;
          if (this.remainTime == 0) {
            this.timeOutItem = true;
          } else {
            this.timeOutItem = false;
          }
        }
        this.$Tool.setStorage("remainTime", this.remainTime);
        this.$store.dispatch("setRemainTime", this.remainTime);
      }, 1000);
    },
    //获取 测评 题目问题详情
    getQuestion(id) {
      evaluationStore
        .getQuestion({
          token: this.studentInfo.token, //登陆获取token
          member_id: this.studentInfo.member_id, //登陆获取的会员表
          student_id: this.studentInfo.student_id,
          question_id: id,
          // question_id: this.currentQuestion.question_id,
          is_analysis: "" //	是否需要题目分析 1-需要 不传为不需要
        })
        .then(res => {
          if (res.data.error == 0) {
            this.currentQuestionList = res.data.result.list;
            let type = res.data.result.list.category_id;
            let _this = this;
            //图片选择 -单选
            console.log(_this.anwsersList, "所以");
            console.log(_this.anwsersList.length);
            //阅读题

            if (_this.anwsersList.length == 0) {
              this.allQuestionList.forEach(function(element) {
                let type1 = parseInt(element.category_id);
                console.log(type1);
                //图片选择 -单选
                let radioObj = {
                  question_id: element.question_id,
                  answers: "",
                  category_id: element.category_id
                };
                let imgClickObj = {
                  question_id: element.question_id,
                  answers: [],
                  category_id: element.category_id
                };
                let linkClickObj = {
                  question_id: element.question_id,
                  answers: [],
                  category_id: element.category_id,
                  pointsArr: [],
                  topList: [],
                  bottomList: []
                };
                var readClickObj = {
                  question_id: "",
                  answers: [],
                  category_id: ""
                };
                if (type1 == 11 || type1 == 15) {
                  _this.anwsersList.push(radioObj);
                } else if (
                  type1 == 16 ||
                  type1 == 19 ||
                  type1 == 13 ||
                  type1 == 14 ||
                  type1 == 21
                ) {
                  _this.anwsersList.push(imgClickObj);
                } else if (type1 == 22) {
                  readClickObj.question_id = element.question_id;
                  readClickObj.category_id = element.category_id;
                  _this.anwsersList.push(readClickObj);
                } else if (type1 == 17) {
                  _this.anwsersList.push(linkClickObj);
                } else {
                  _this.anwsersList.push(radioObj);
                }
              });
            }

            if (type == 22) {
              let list = res.data.result.list;
              let idsArr = res.data.result.list.ids;
              this.questionsIdList = [];
              // console.log(res.data.result.list)
              _this.readListContentAll = list;

              _this.readListContent = [];
              idsArr.forEach((item, index) => {
                // console.log(item, index);
                let obj = {
                  question_id: item.question_id,
                  answers: ""
                };


                if (_this.isClickPrev) {
                  if (
                    _this.anwsersList[_this.question.currentId].answers.length <
                    idsArr.length
                  ) {
                    _this.anwsersList[_this.question.currentId].answers.push(
                      obj
                    );
                  }
                }
                this.questionsIdList.push(item.question_id);
                // _this.anwsersList.push(readClickObj);
              });

              _this.getQuestion1(this.questionsIdList);

            }
            console.log(_this.anwsersList, _this.anwsersList.length);
            console.log(this.currentQuestionList, "问题详情");
          }
        });
    },
    //获取 测评 题目问题详情----阅读题--接口
    getQuestion1(ids) {
      let id = ids[0];
      let other = [];

      if (ids.length > 1) {
        other = ids.slice(1, ids.length);
      }

      evaluationStore
        .getQuestion({
          token: this.studentInfo.token, //登陆获取token
          member_id: this.studentInfo.member_id, //登陆获取的会员表
          student_id: this.studentInfo.student_id,
          question_id: id,
          // question_id: this.currentQuestion.question_id,
          is_analysis: "" //	是否需要题目分析 1-需要 不传为不需要
        })
        .then(res => {
          if (res.data.error == 0) {
            let list = res.data.result.list;
            // this.readListContentAll.readListContent.push(list);
            this.readListContent.push(list);
            this.currentQuestionList = this.readListContentAll;
            console.log(this.readListContentAll, "所有的题目详情");
            console.log(this.currentQuestionList, "问题详情");
          }
          if (ids.length > 1) {
            this.getQuestion1(other);
          }
        });
    },
    //提交
    completeSubmit() {
      let _this = this;
      _this.submitArr = [...this.anwsersList];
      _this.submitArr.forEach(function(item, index) {

        let type = item.category_id;
        if (type == 13 || type == 14 || type == 21) {
          let str = "";
          if (item.answers != "") {
            item.answers.forEach(function(item1, index1) {
              if (index1 == 0) {
                str = str + item1.answers_optionname;
              } else {
                str = str + "|" + item1.answers_optionname;
              }
            });
            console.log(str, "str==============");
            _this.submitArr[index].answers = str;
          }
        } else if (type == 19 || type == 16) {
          //图片点击题 - 多选
          let str = "";
          if (item.answers != "") {
            item.answers.forEach(function(item1, index1) {
              console.log(item1, index1);
              if (index1 == 0) {
                str = str + item1;
              } else {
                str = str + "|" + item1;
              }
            });
            _this.submitArr[index].answers = str;
          }
        } else if (type == 17) {

          delete _this.submitArr[index].topList;
          delete _this.submitArr[index].bottomList;
          delete _this.submitArr[index].pointsArr;

          let str = "";
          if (item.answers.length > 0) {
            str = item.answers.join("|");
            _this.submitArr[index].answers = str;
          }
          console.log(str);
        }
      });
      console.log(this.anwsersList);
      console.log(_this.submitArr, "str---------------------------------");

      if (this.studentInfo.myIsErroy == 0) {
        console.log("我是正常提交");
        this.getScore();
      } else if (this.studentInfo.myIsErroy == 1) {
        console.log("错题计较一次");
        this.getSmallWrongScore();
      }
    },
    //提交 - 接口
    getScore() {
      let time =
        this.$Tool.getStorage("allTime") - this.$store.state.remainTime;
      evaluationStore
        .getScore({
          token: this.studentInfo.token, //登陆获取token
          member_id: this.studentInfo.member_id, //登陆获取的会员表
          student_id: this.studentInfo.student_id,
          examine_branch: this.studentInfo.examine_branch, //检测编号
          answer_list: JSON.stringify(this.submitArr), //答案的集合
          examine_examtime: time / 60, //学生答题时间
          question_num: this.allQuestionList.length, //	题目总数
          classcode_branch: this.studentInfo.examine_branch //班别编号
        })
        .then(res => {
          if (res.data.error == 0) {
            let list = res.data.result.list;
            this.$Tool.setStorage("getCodeInfo", list);
            this.$store.dispatch("setgetCodeInfo", list);
            clearInterval(this.timer_cout);
            if(this.$route.query.from == 'task'){//标识是从 作业任务的检测任务 过来的
              this.$router.push({
                path: "/studyEvaluate/answerResult",
                query: {
                  examine_branch: this.studentInfo.examine_branch,
                  examine_name: escape(this.studentInfo.examine_name),
                  isSource:1,
                  mySourceErroy:this.$route.query.mySourceErroy?this.$route.query.mySourceErroy:0,//错题练习 - 标识(和单园练习同页面的这个)
                  taskitem_id:this.$route.query.taskitem_id,
                  from:this.$route.query.from,//标识是从 作业任务的检测任务 过来的
                }  
              })
              this.$Tool.setStorage("setTask", 0); // 我刚刚已经从  作业任务的检测任务 过来了
            }else{
              this.$router.push({
                path: "/studyEvaluate/answerResult",
                query: {
                  examine_branch: this.studentInfo.examine_branch,
                  examine_name: escape(this.studentInfo.examine_name),
                  isSource:1,
                  mySourceErroy:this.$route.query.mySourceErroy?this.$route.query.mySourceErroy:0,//错题练习 - 标识(和单园练习同页面的这个)
                }
              });
            }
          }
        });
    },
    //错题题目提交 - 接口
    getSmallWrongScore() {
      let time =
        this.$Tool.getStorage("allTime") - this.$store.state.remainTime;
      evaluationStore
        .getSmallWrongScore({
          token: this.studentInfo.token, //登陆获取token
          member_id: this.studentInfo.member_id, //登陆获取的会员表
          student_id: this.studentInfo.student_id,
          examine_branch: this.studentInfo.examine_branch, //检测编号
          answer_list: JSON.stringify(this.submitArr), //答案的集合
          examine_examtime: time / 60, //学生答题时间
          question_num: this.allQuestionList.length, //	题目总数
          classcode_branch: this.studentInfo.examine_branch //班别编号
        })
        .then(res => {
          if (res.data.error == 0) {
            let list = res.data.result.list;
            this.$Tool.setStorage("getCodeInfo", list);
            this.$store.dispatch("setgetCodeInfo", list);
            // this.$Tool.setStorage("remainTime", 1); //考试时间
            // this.$store.dispatch("setRemainTime", 1);
            clearInterval(this.timer_cout);
            this.$router.push({
              path: "/studyEvaluate/answerResult",
              query: {
                examine_branch: this.studentInfo.examine_branch,
                examine_name: escape(this.studentInfo.examine_name),
                isSource:0,
              }
            });
          }
        });
    },
    //本题答题作废 取消
    handleCloseTip() {
      this.timeOutItem = false;
      this.$router.push({
        path: "/studyEvaluate/evaluateChild",
        query: {
          textbook_id: this.$store.state.textBookId,
          textbook_cnname: escape(this.studentInfo.examine_name)
        }
      });
    },
    //本题答题作废 确定
    handConfirm() {
      this.timeOutItem = false;
      this.$router.push({
        path: "/studyEvaluate/evaluateChild",
        query: {
          textbook_id: this.$store.state.textBookId,
          textbook_cnname: escape(this.studentInfo.examine_name)
        }
      });
    },
    //当前做题是否是 点击了浏览器的返回上一页
    goBack() {
      this.closeItem = true;
      console.log(document.URL);
      // console.log("点击了浏览器的返回按钮");
      // history.pushState(null, null, document.URL);
    },
    //返回上一页 - 确定
    handConfirmEquit() {
      console.log("退出");
      this.closeItem = false;
      //  this.$router.go(-1);
      let allTime = this.$Tool.getStorage("allTime");
      console.log(allTime);
      this.$Tool.setStorage("remainTime", 0); //考试时间
      this.$store.dispatch("setRemainTime", 0);
      if(this.$route.query.from == 'task'){
        this.$router.push({
          path: "/TaskCenter",
        });
      }else{
        this.$router.push({
          path: "/studyEvaluate/evaluateChild",
          query: {
            textbook_id: this.$store.state.textBookId,
            textbook_cnname: escape(this.$store.state.textbookCnname)
          }
        });
      }
    },
    //返回上一页 - 取消
    handCancelEquit() {
      this.closeItem = false;
      history.pushState(null, null, document.URL);
    },
    //返回上一页 - 关闭
    handleCloseTipEquit() {
      this.closeItem = false;
      history.pushState(null, null, document.URL);
    }
  },
  destroyed() {
    window.removeEventListener("popstate", this.goBack, false);
    // window.removeEventListener("beforeunload", e => this.beforeunloadFn(e));
  },
  beforeDestroy() {
    if (this.timer_cout) {
      clearInterval(this.timer_cout); //关闭
    }
  }
};
</script>

<style lang="stylus">
@import './study-center1.styl';
</style>
